import {
  Action,
  ActionType,
  UpdateUserStatusResponse,
} from "models/userListBusiness/updateUserStatus";

import createReducer from "../../createReducer";

export interface UpdateUserStatusReducerType {
  loading: boolean;
  error?: string;
  updateUserStatusResponse?: UpdateUserStatusResponse;
}

const defaultState: UpdateUserStatusReducerType = {
  loading: false,
  error: undefined,
  updateUserStatusResponse: undefined,
};

export const updateUserStatusReducer =
  createReducer<UpdateUserStatusReducerType>(defaultState, {
    [ActionType.UPDATE_USER_STATUS](state: UpdateUserStatusReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.UPDATE_USER_STATUS_ERROR](
      state: UpdateUserStatusReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.UPDATE_USER_STATUS_SUCCESS](
      state: UpdateUserStatusReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        updateUserStatusResponse: action.payload,
      };
    },

    [ActionType.UPDATE_USER_STATUS_RESET](state: UpdateUserStatusReducerType) {
      return {
        ...state,
        loading: false,
        error: null,
        updateUserStatusResponse: undefined,
      };
    },
  });
